import { IRoute } from "../../../common/helpers/routesMapper";

import withRouter from "../../utils/withRouter";
import { connect } from "react-redux";
import injectIntl from "../../../common/helpers/injectIntl";
import { Store } from "redux";

import resetPlan from "../../store/plan/actions/resetPlan";
import taskCompleted from "../../store/plan/actions/taskCompleted";
import getPlan from "../../store/plan/actions/getPlan";
import { post } from "../../actions/general";

import { seo } from "../../../common/helpers/seo";
import getPlanSeo from "../../../common/helpers/getPlanSeo";
import { IStateTree } from "../../store/interfaces";

import routing from "../../routing";

import lazyComponent from "./lazy";
import { IPlan } from "../../../common/types";
import { IPlanState } from "../../store/plan/models";
import { IUser } from "../../store/user/models";

const sharePath = `/${routing.share}`;

const mapStateToProps = ({ user, plan }: IStateTree) => ({
    user: user as IUser,
    plan: plan as IPlan & IPlanState,
});

export default {
    component: withRouter(
        injectIntl(connect(mapStateToProps, { getPlan, resetPlan, post, taskCompleted })(lazyComponent))
    ),
    loadData: ({ dispatch }: Store<IStateTree, any>, path: string) => dispatch(getPlan(path)),
    renderSeo: (
        { getState }: Store<IStateTree>,
        allMessage: {[prop: string]: string},
        lang: string,
        path: string,
        context: { redirect?: string },
    ) => {
        const plan = getState().plan as IPlan;
        if (plan.redirect) {
            context.redirect = `/${routing.publicPlay}/${plan.publicId}`;
            return;
        }
        if (path.slice(0, sharePath.length) === sharePath && !(getState().user as IUser)?.loggedIn) {
            context.redirect = path.replace(sharePath, `/${routing.publicPlay}`); // TODO do it after user action
        }
        if (!plan || (plan as {
            loading?: boolean,
            error?: boolean,
            notFound?: boolean,
        }).error) {
            return seo({
                title: allMessage.notFound,
                type: "article",
                noindex: true,
                allMessage,
                lang,
            });
        }
        return seo({
            ...getPlanSeo(plan, { locale: lang }),
            allMessage,
            lang,
        });
    },
} satisfies IRoute;
